import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <g fill="#8091A5" fillRule="evenodd">
      <path d="M1.929 17.999v-3.651H14.4v3.651z" />
      <circle cx="4.783" cy="7.354" r="4.783" />
      <path d="M18.001 14.194L9.772.206h8.229z" />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/spacetemplate-tea.es6.js